<template>
  <div class="purchase-goods-page">
    <div class="inquire-module">
      <a-form>
        <a-row :gutter="24">
          <a-col :md="3" :sm="6">
            <a-form-item label="">
              <a-select labelInValue style="width: 100%;" placeholder="选择分类" @change="selectWarehouse">
                <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                <a-select-option value="jack" v-for="(item, index) in warehouseList" :key="index"></a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="6">
            <a-form-item label="">
              <a-select labelInValue style="width: 100%;" placeholder="杭州萧山分库" @change="selectWarehouse">
                <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                <a-select-option value="jack" v-for="(item, index) in warehouseList" :key="index"></a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="6">
            <a-form-item label="">
              <a-input placeholder="输入单据编号搜索" v-model="formData.abstract" />
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="6" class="button-ant-col">
            <a-button class="ant-btn-color border-arc">查询</a-button>
            <a-button class="border-arc">重置</a-button>
          </a-col>
          <a-col :md="12" :sm="6" class="button-add-col">
            <a-button icon="upload" class="ant-btn-color border-arc">导出</a-button>
            <a-button icon="printer" type="primary border-arc">打印</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="purchase-goods-table">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" bordered>
        <template slot="operation">
          <a-dropdown>
            <img src="@/assets/image/gengduo.png" alt="" style="width: 12px;">
            <a-menu slot="overlay">
              <!-- <a-menu-item>
                                <a>复制链接</a>
                            </a-menu-item> -->
              <a-menu-item @click="btnGoSellOrderDetails">
                <a>生成采购入库单</a>
              </a-menu-item>
              <a-menu-item>
                <a>编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a>删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>
    </div>
    <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" ::default-current="ipagination.current" :show-total="ipagination.showTotal" show-size-changer show-quick-jumper />
    </div>
  </div>
</template>
<script>
import pick from 'lodash.pick'
export default {
  name: 'makeOffersList',
  data () {
    return {
      visible: false,
      columns: [
        {
          title: '#',
          width: '180px',
          align: 'center',
          dataIndex: 'rowIndex',
          customRender: function (text, r, index) {
            return (text !== '合计') ? (parseInt(index) + 1) : text
          }
        },
        {
          title: '姓名',
          dataIndex: 'name',
        },
        {
          title: '贡献点',
          dataIndex: 'point',
        },
        {
          title: '等级',
          dataIndex: 'level',
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
        }
      ],
      formData: {
        unit: '',
        warehouse: '',
        agent: '',
        abstract: '',
        remark: '',
        offerPrices: ''
      },
      warehouseList: [],
      dataSource: [{ name: '张三', point: 23, level: 3, updateTime: '2019-8-14' },
      { name: '小王', point: 6, level: 1, updateTime: '2019-8-13' },
      { name: '李四', point: 53, level: 8, updateTime: '2019-8-12' },
      { name: '小红', point: 44, level: 5, updateTime: '2019-8-11' },
      { name: '王五', point: 97, level: 10, updateTime: '2019-8-10' },
      { name: '小明', point: 33, level: 2, updateTime: '2019-8-10' },],
      ipagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 100
      }
    }
  },
  mounted () {
    this.tableAddTotalRow(this.columns, this.dataSource)
  },
  methods: {
    /** 表格增加合计行 */
    tableAddTotalRow (columns, dataSource) {
      let numKey = 'rowIndex'
      let totalRow = { [numKey]: '合计' }
      columns.forEach(column => {
        let { key, dataIndex } = column
        if (![key, dataIndex].includes(numKey)) {

          let total = 0
          dataSource.forEach(data => {
            total += /^\d+\.?\d?$/.test(data[dataIndex]) ? Number.parseInt(data[dataIndex]) : Number.NaN
            // console.log(data[dataIndex], ':', (/^\d+\.?\d?$/.test(data[dataIndex]) ? Number.parseInt(data[dataIndex]) : Number.NaN))
          })

          if (Number.isNaN(total)) {
            total = '-'
          }
          totalRow[dataIndex] = total
        }
      })
      dataSource.push(totalRow)
    },
    // 选择仓库
    selectWarehouse () {

    },
    // 查看详情
    btnGoSellOrderDetails () {
      this.$router.push({ path: '/purchase/purchaseasmin/purchaseOrderDetails' })
    }
  }
}
</script>

<style lang="scss">
.purchase-goods-page {
  .inquire-module {
    padding: 30px;
    background-color: #ffffff;
    .ant-form-item-children {
      width: 100%;
      .ant-calendar-picker {
        width: 100%;
      }
      .ant-calendar-picker-input {
        width: 100% !important;
      }
    }
    .button-ant-col {
      display: flex;
      .ant-btn {
        width: 80px !important;
      }
      .ant-btn-color {
        margin-right: 16px;
      }
    }
    .button-add-col {
      display: flex;
      justify-content: flex-end;
      .ant-btn {
        font-size: 16px;
        margin-left: 16px;
        // .anticon  {
        //     font-size: 18px;
        // }
      }
    }
    .ant-form-item {
      margin-bottom: 0 !important;
    }
  }
  .purchase-goods-table {
    margin-top: 20px;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 10px 0 !important;
          .ant-input {
            border-radius: 0 !important;
          }
        }
      }
    }
  }

  .pagination-box {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
  }
}
</style>